export default __webpack_public_path__ + "static/media/local_red.10cde9ae.svg";